import React, { useState, useEffect } from "react";
import "react-tabs/style/react-tabs.css";
import TabItems from "./TabItems";
import "./courseView.css";
import Course from "../course/Course";
import thumbnailImg from "../../template/images/course_thumbnail.png";
import Header from "../layout/Header";
import Footer from "../layout/Footer";
import PopularCourse from "../popularCourse/PopularCourse";
import { get, post } from "../../util/axiosConfig/AxiosConfig";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";

const PopularCourseView = () => {
  const { courseId } = useParams();
  const [loading, setLoading] = useState(false);
  const [coursesDataDetails, setCoursesDataDetails] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
    fetchCoursesDataDetails();
  }, []);

  const fetchCoursesDataDetails = async () => {
    console.log(courseId, "iddddddddddddddd");
    try {
      setLoading(true);
      const response = await get(
        `web/api/v1/lms-web/open/get-course-details/${courseId}`
      );
      setCoursesDataDetails(response);
    } catch (error) {
      setLoading(false);
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const manageEnroll = () => {
    navigate(`/subscription/${courseId}`)
  }

  function getTrainerFullName(trainer) {

    let fullName = '';
     fullName = trainer.firstName;
    if (trainer.middleName) {
        fullName += " " + trainer.middleName;
    }
    if (trainer.lastName) {
        fullName += " " + trainer.lastName;
    }
    return fullName;
}


  return (
    <React.Fragment>
      <Header />
      <div className="course_banner_sectioon">
        <div className="page_banner_inner">
          <div className="container">
            <div className="banner_text">
              <h4 className="banner_course_title">{coursesDataDetails.courseName}</h4>
              <p className="banner_course_description">
                {coursesDataDetails.description}
              </p>
            </div>
          </div>
        </div>
        <div className="course_info">
          <div className="container">
            <h4 className="course_name_view">
              Learn the {coursesDataDetails.courseName}
            </h4>
            <div className="course_instruction">
              <div className="course_ins_left">
                <div className="instructor">
                  <p className="instructur_heading">Instructor</p>
                  <p className="instructur_name">
                    { 
                      coursesDataDetails && coursesDataDetails.trainer ? getTrainerFullName(coursesDataDetails.trainer) : ''
                    }
                  </p>
                </div>
                <div className="enrolled">
                  <p className="enrolled_heading">Students Enrolled</p>
                  <p className="enrolled_number">
                  {coursesDataDetails.userCount}
                  </p>
                </div>
              </div>
              <div className="course_ins_right">
                <p className="view_amount">₹ {coursesDataDetails.minPrice} /-</p>
                <p className="enrolled_now_btn">
                  <button className="enroll_now_btn" onClick={()=>manageEnroll()}>Enroll Now</button>
                </p>
              </div>
            </div>
            <div className="course_thumbnail">
              <img
                // src={`data:image/png;base64,${coursesDataDetails.coverImage}`}
                src={coursesDataDetails.coverImage}
                className="img-fluid course_thumbnil_img"
                alt="Course thumbnail"
              />
            </div>
          </div>
        </div>
        <div className="tab_view mb-5">
          <div className="container">
            <TabItems courseTabDetails={coursesDataDetails}/>
            {/* <div className="popular_course">
              <PopularCourse />
            </div> */}
          </div>
        </div>
      </div>
      <Footer />
    </React.Fragment>
  );
};

export default PopularCourseView;
